import React, { useEffect, useState } from "react";
import { Helmet } from 'react-helmet';

import { Button, Menu, MenuItem, } from "@material-ui/core";

import { Add as AddIcon, } from "@material-ui/icons";

import { Centered, CircularProgress, Paper, Typography } from "../../../../common/components/libs";
import styles from "./style.module.css"
import NoCategories from "./components/NoCategories";
import { FadeInOutVertical } from "../../../../common/components/Animated";
import EditMenuCategoryForm from "./components/EditMenuCategoryForm";
import CategoriesTabs from "./components/MenuCategories";
import EditMenuItemForm from "./components/EditMenuItemForm";
import CreateMenuItemForm from "./components/CreateMenuItemForm";
import NoMenuItems from "./components/NoMenuItems";
import { observer } from "mobx-react";
import { useStores } from "../../../../hooks";
import { useParams } from "react-router-dom";
import { localize } from "../../../../common/libs";
import EditMenuCategoriesForm from "./components/EditMenuCategoriesForm";
import { useHistory } from "react-router-dom";
import EditMenuItemsOrdersForm from "./components/EditMenuItemsOrdersForm";
import HeaderButton from "./components/HeaderButton";
import {useTranslation} from "react-i18next";
import DeleteMenuCategoryForm from "./components/DeleteMenuCategoryForm";
import CopyMenuItemForm from "./components/CopyMenuItemForm";


const MenuEditorPage = () => {
    const { menuStore, generalStore, translationStore, modifiersSetsStore } = useStores();

    const [isLoading, setIsLoading] = useState(true);
    const { menuId } = useParams();
    const history = useHistory();
    const {t} = useTranslation(["general", "menu"]);

    const navigateTo = (link: string) => {
        history.push(link);
    };
    useEffect(() => {
        menuStore.fetchMenuById(menuId);
    }, [menuId, menuStore]);

    useEffect(() => {
        const menu = menuStore.currentMenu?.menu;
        if (!menu) return;
        generalStore.setPageTitle(localize(menu.data.name), <HeaderButton/>);

        setIsLoading(false)
        translationStore.setLangs(menu.data.availableLanguages)
        modifiersSetsStore.ensureLoaded()
    }, [menuStore.currentMenu, generalStore]);


    const { currentMenu, selectedCategory } = menuStore;

    if (!currentMenu || isLoading) {
        return <FadeInOutVertical show={!isLoading}>
            <Centered>
                <Paper mt={2} style={{ padding: 40 }}>
                    <Typography variant="body2">
                        {t("general:loading")}
                    </Typography>
                    <CircularProgress m={2}/>
                </Paper>
            </Centered>
        </FadeInOutVertical>
    }
    const { menuCategories } = currentMenu;


    const renderCategoryContent = () => {
        const currentCategory = menuCategories[selectedCategory];
        if (!currentCategory) return null;

        const { menuItemsByCategoryId } = currentMenu;
        const menuItems = menuItemsByCategoryId[currentCategory.id] || [];
        if (menuItems.length > 0) {
            return menuItems.map(item => {
                return <FadeInOutVertical show={true} key={item.id}>
                    <Paper mb={4}>
                        <div style={{ padding: "20px 20px 15px 20px" }}
                             onClick={(e) => {
                                 navigateTo(
                                     `/menus/regular/${menuStore.currentMenu.id}/${currentCategory.id}/${item.id}`
                                 )
                             }}
                        >
                            <EditMenuItemForm
                                key={item.id}
                                category={currentCategory}
                                current={item}
                            />
                        </div>
                    </Paper>
                </FadeInOutVertical>
            })

        } else {
            return <FadeInOutVertical show={true}>
                <Centered>
                    <NoMenuItems/>
                </Centered>
            </FadeInOutVertical>
        }
    };
    let content = [];

    if (menuCategories.length === 0) {
        content.push(
            <FadeInOutVertical show={true}
                               key="1"
            >
                <Centered>
                    <NoCategories/>
                </Centered>
            </FadeInOutVertical>
        )
    } else {
        content.push(
            <FadeInOutVertical show={true} key='2'>
                <div className={styles.menuEditorContainer}>
                    <CategoriesTabs/>
                </div>
            </FadeInOutVertical>
        );
        content.push(
            <FadeInOutVertical show={true} key={'3'}>
                <div className={styles.menuItemsContainer}>
                    {renderCategoryContent()}
                </div>
            </FadeInOutVertical>
        )
    }

    return (
        <>
            <Helmet title={t("menu:menuEditor.yourMenus")}/>
            {content}
            <CopyMenuItemForm/>
            <CreateMenuItemForm/>
            <EditMenuCategoryForm/>
            <EditMenuCategoriesForm/>
            <EditMenuItemsOrdersForm/>
            <DeleteMenuCategoryForm/>
        </>
    );

};

export default observer(MenuEditorPage);
